import * as types from '../constants/ActionTypes';
import initialState from './initialState';

export default function(state = initialState.keycloak, action) {
  switch (action.type) {
    case types.AUTH_LOGIN_START:
      return {
        ...state,
        isLoggingIn: true,
        isLoggedIn: false,
        error: null
      };

    case types.AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        isLoggingIn: false,
        isLoggedIn: true,
        user: action.payload.user,
        error: null
      };

    case types.AUTH_LOGIN_FAILURE:
      return {
        ...state,
        isLoggingIn: false,
        isLoggedIn: false,
        error: action.payload.error
      };

    case types.AUTH_LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        isLoggingIn: false,
        user: null
      };

    case types.AUTH_CHECK_PUBLIC_ROUTE:
      return {
        ...state,
        isPublicRoute: action.payload.isPublic
      };

    case types.AUTH_RESET_LOGIN_STATE:
      return {
        ...state,
        isLoggingIn: false
      };

    case types.REINICIAR:
      return initialState.keycloak;

    default:
      return state;
  }
}
